if ( pplang == 'ko') {

    var ko_strings =
    {
        "globals": {
            "_globalnotice": "여기에서 등록하세요",
            "_globalnotice2": regname+" 티켓 등록을 이제 시작합니다!",
            "_globalnoticereg": "이메일을 확인해보세요! 내일 티켓 판매에 대한 구매 안내문을 발송했습니다.",
            "_maintenance": "Ultra Passport를 현재 사용할 수 없습니다. 잠시 후 다시 확인하십시오.",
            "_guestnotice": "이 페이지를 보려면 로그인 해야 합니다."
        },
        "form_labels": {
            "_fullname": "성함",
            "_firstname": "이름",
            "_lastname": "성",
            "_email": "이메일",
            "_emailaddy": "메일 주소",
            "_confirmemailaddy": "메일 주소 확인",
            "_birthday": "생일",
            "_location": "위치",
            "_country": "국가",
            "_homeevent": "홈 이벤트",
            "_gender": "성별",
            "_password": "비밀번호",
            "_male": "남성",
            "_female": "여성",
            "_pleaseselect": "선택하세요",
            "_signuptitle": "Ultra Passport등록",
            "_enteryouremail": "메일 주소를 입력해주세요.",
            "_backtologin": "로그인으로 돌아가기",
            "_requestnewpass": "새로운 비밀번호를 요청합니다.",
            "_on": "온",
            "_off": "오프",
            "_goback" : "뒤로 가기"
        },
        "labels": {
            "_enrollmentavailable": "지금 등록 가능합니다.",
            "_logintext": "로그인",
            "_password": "비밀번호",
            "_welcome": "환영합니다.",
            "_account": "계정",
            "_myaccount": "나의 계정",
            "_events": "이벤트",
            "_points": "포인트",
            "_updates": "업데이트",
            "_signout": "로그아웃",
            "_signin": "로그인",
            "_signedin": "로그인 됨",
            "_signuptext": "가입",
            "_nextlevel": "다음 단계",
            "_forgot": "비밀번호 찾기",
            "_subscribed": "가입 완료",
            "_helpcenter": "도움말",
            "_error": "오류",
            "_silver": "실버",
            "_gold": "골드",
            "_platinum": "플레티넘"
        },
        "validation_messages": {
            "_gendertext": "성별을 선택하세요.",
            "_accepttext": "위의 항목에 동의하세요."
        },
        "_email_verifications": {
            "_resendverify": "확인 메일 다시 보내기",
            "_revalidate": "새로운 메일 주소를 승인하려면 이메일을 확인하세요.",
            "_sendingverification": "확인 메일 발송 중...",
            "_verifysent": "확인 메일 발송 완료",
            "_emailverifydashboard": "업데이트 및 티켓 등록 사항을 확인하려면 반드시 메일을 인증하세요.",
            "_emailverifyupdates": "이메일 업데이트 사항을 활성화하려면 메일을 인증하세요."
        },
        "_edit_page": {
            "_editaccount": "계정 수정",
            "_nochanges": "변경 사항이 적용되지 않았습니다.",
            "_accountupdated": "계정이 업데이트 되었습니다.",
            "_emailupdatedstarted": "새로운 메일 주소를 인증해야 합니다. 승인하려면 이메일을 확인하세요.",
            "_emailupdatedverified": "새로운 메일 주소가 인증되었습니다.",
            "_passwordresetsent": "비밀번호 재설정 메일이 발송되었습니다."
        },
        "_footer_signup": {
            "_startinput": "시작하려면 메일 주소를 입력하세요.",
            "_starttext": "계정이 없으십니까?  <br class=\"small-hide\">에 등록해서 이벤트 소식을 받고 포인트를 확득하려면 가입하십시오.",
            "_getstarted": "시작하기"
        },
        "_signup_page": {
            "_createaccount": "나의 계정 생성하기",
            "_almost": "완료되는 중...",
            "_almost2": "$user_firstname 축하합니다! 당신의 Ultra Passport<span class=\"tm\">™</span> 계정이 생성되었습니다.",
            "_almost3": "계정을 활성화하려면 방금 <strong>$user_email</strong>로 발송된 확인 링크를 클릭하여 <strong><u>당신의 메일 주소 반드시 인증하세요.</u></strong>",
            "_almost4": "메일 <strong><u>을 받지 못한 경우 스팸 폴더</u></strong>를 확인하고<strong><u>info@ultrapassport.com</u></strong>을<strong><u>주소록에 추가하십시오.</u></strong>",
            "_almost5": "계속",
            "_createdsuccess": "계정이 생성되었습니다.",
            "_createdinfo": "계정이 생성되는 중입니다.",
            "_accountactivated": "계정이 활성화되었습니다.",
            "_accountverified": "메일 주소가 인증되지 않았습니다.",
            "_passwordresetsuccess": "비밀번호 재설정이 완료되었습니다."
        },
        "_updates": {
            "_updatestext1": "업데이트를 등록하려면 로그인해야 합니다.",
            "_updatestextPending": "업데이트를 받으려면 이메일 주소를 인증해야 합니다.",
            "_updatessubsrcibe": "다음 항목에 대한 업데이트 수신을 허용하셨습니다.",
            "_updatesunsubsrcibe": "다음 항목의 업데이트 사항에 대한 수신을 허용하지 않았습니다."
        },
        "_registration": {
            "_rbtnbuy": "지금 티켓 구매하기",
            "_regbuy": "티켓 구매",
            "_rbtnregister": "티켓  등록",
            "_rbtnclosed": "만료",
            "_rbtnsoon": "커밍 순",
            "_rbtnupdates": "업데이트 하기",
            "_verifyemailregister": "등록하기 전에 메일 주소를 인증해야 합니다.",
            "_regbtnhtml": "등록되었습니다.",
            "_regerror": "오류!",
            "_regerror2": "다시 시도해주세요",
            "_regprocessing": "등록이 처리 중입니다...",
            "_registersuccess": "등록 성공",
            "_regaccepted": "등록이 완료되었습니다.",
            "_regaccepted2": "티켓 구매 안내는 판매를 시작하기 24-48시간 전에 이메일로 발송됩니다.",
            "_regdone1": "등록 코드",
            "_regdone2": "기재된 내용을 확인하세요.",
            "_regdone3": "구매 안내문 다시 보내기",
            "_selectregtype": "등록 유형 선택",
            "_regtype": "등록 유형",
        },
        "_registration_confirm": {
            "_regtext1": "당신이 기입한 정보가 업데이트 되었습니까?",
            "_regtext2": "등록 정보를 확인하세요.",
            "_regguest1": "이벤트 등록을 하려면 로그인해야 합니다.",
            "_regpending1": "거의 다 왔습니다!",
            "_regpending2": "등록 접근 권한를 해제하려면 <strong> 메일 주소 </strong>를 인증하세요.",
            "_updateinfobtn": "나의 정보 업데이트",
            "_confirmreg": "나의 등록 확인",
            "privacytext": "개인 정보 보호 정책",
            "termsofuse": "이용약관",
            "_agreesignup": "Ultra Passport개인 정보 보호 정책 및 사용 약관에 동의합니다.",
            "_agreesignup2": "등록하면 Ultra Passport 개인 정보 보호 정책 및 사용 약관에 동의하게 됩니다.",
            "_agreeregister": "등록하면 Ultra Passport 개인 정보 보호 정책 및 사용 약관에 동의하게 됩니다."
        },
        "_errors": {
            "reset": "잘못된 메일 주소 또는 만료된 토큰입니다.",
            "create": "작성에 실패하였습니다. 쿠키를 사용 가능으로 설정했는지 확인하세요.",
            "general": "이런! 뭔가 잘못됐어요. 쿠키가 활성화되어 있는지 확인하세요.",
            "password": "비밀번호는 8자 이상이어야 합니다.",
            "duplicateemail": "이메일 계정이 이미 사용 중입니다.",
            "loginfail": "사용자 이름과 비밀번호가 일치하지 않습니다. 확인하고 다시 시도해주세요.",
            "token": "토큰이 잘못되었습니다. 로그인 하고 <b>인증메일을 전송하세요. </b>"
        },
        "_passport_labels": {
            "_action": "액션",
            "_awarded": "어워드",
            "_award": "어워드",
            "_pointsexpire": "*25개월 후 포인트가 만료됩니다.",
            "_qualifydisclaimer": "*Ultra Festival에는 Road To Ultra,Ultra Beach,Resistance가 포함되지 않습니다.",
            "_benefit": "혜택",
            "_sample": "포인트 어워드",
            "_active": "활성화",
            "_deleted": "삭제되었습니다.",
            "_btn_dashboard": "대시보드",
            "_btn_benefits": "혜택",
            "_btn_qualify": "자격",
            "_btn_points": "나의 포인트",
            "_howtoqualify": "자격 부여 방법"
        },
        "_point_labels": {
            "_points_manual": "패스포트 관리 설정",
            "_points_verify": "계정 메일 주소를 인증해주세요.",
            "_points_unknown" : "패스포트 관리 설정",
            "_points_attend_festival": "로드 투 Ultra Festival 이벤트에 참가하기",
            "_points_attend_rtu" : "Road to Ultra 이벤트 참가하기",
            "_points_attend_resistance" : "Resistance 이벤트 참가하기",
            "_points_away_bonus": "다른 국가의 이벤트 참가하기",
            "_points_home_bonus_1": "홈 이벤트 참가하기",
            "_points_home_bonus_2": "홈 이벤트 x2 참가하기",
            "_points_home_bonus_3": "홈 이벤트 x3 참가하기"
        },

        /*"// PHP LABELS": {
            "$newpassword": "새로운 비밀번호를 입력해주세요.",
            "$chooseanewpass": "새로운 비밀번호를 선택해주세요.",
            "$enteryouremail": "메일 주소를 입력해주세요.",
            "$optional": "선택"
        },
        "// BUTTON TEXT": {
            "$goback": "뒤로 가기",
            "$login": "로그인",
            "$signup": "등록",
            "$requestnewpass": "새로운 비밀번호를 요청합니다.",
            "$buttonverify": "인증",
            "$resetpassword": "비밀번호 재설정",
            "$createmyaccount": "나의 계정 생성하기",
            "$updatemyaccount": "나의 계정 업데이트",
            "$backtologin": "로그인으로 돌아가기",
            "$forgotpass": "비밀번호 찾기"
        },
        "// CONTENT": {
            "$abouttitle": "내 정보",
            "$upptitle": "패스포트 정보",
            "$updatestext": "업데이트된 소식을 받고 싶은 이벤트를 선택하세요.",
            "$allupdates": "모든 업데이트 받기",
            "$disableall": "모두 사용 안함",
            "$terms1": "동의합니다.",
            "$terms2": "가입하면 동의하게 됩니다.",
            "$privacypolicy": "개인 정보 보호 정책",
            "$termsofuse": "이용 약관",
            "$and": "그리고",
            "$guestnotice": "이 페이지를 보려면 로그인해야 합니다.",
            "$searchtext": "이벤트를 검색하려면 입력해주세요..."
        },
        "// DASHBOARD": {
            "$myaccount": "나의 패스포트",
            "$points": "포인트",
            "$nextlevel": "다음 단계",
            "$name": "성함",
            "$location": "위치",
            "$customerid": "고객 ID",
            "$created": "생성되었습니다.",
            "$level": "레벨",
            "$eventsbtn": "이벤트",
            "$updatesbtn": "업데이트",
            "$editaccount": "계정 수정",
            "$ppdetails": "패스포트 정보",
            "$ppid": "패스포트 ID",
            "$ppunlock": "다음 레벨까지 필요한 포인트",
            "$status": "상태"
        },
        "// URL SLUGS": {
            "$accountpath": "패스포트",
            "$loginpath": "로그인",
            "$signuppath": "가입",
            "$lostpath": "잃다",
            "$resetpath": "재설정",
            "$eventspath": "이벤트",
            "$verifypath": "인증",
            "$changeemail": "메일 주소 변경하기",
            "$editpath": "수정",
            "$updatespath": "업데이트"
        },
        "// PAGE TITLES": {
            "title_my_passport": "나의 패스포트",
            "title_Login": "로그인",
            "title_ultra_passport_enrollment": "Ultra Passport등록",
            "title_reset_your_password": "비밀번호 재설정",
            "title_update_your_password": "비밀번호 업데이트",
            "title_events": "이벤트",
            "title_verify": "인증",
            "title_change_email": "메일 주소 변경하기",
            "title_edit_my_account": "내 계정 수정하기",
            "title_manage_updates": "업데이트 관리하기"
        },*/
        "_benefits": {
            "_silverbenefits_1": "가장 먼저 Ultra얼리버드 티켓 등록하기",
            "_goldbenefits_1": "실버 레벨보다 먼저 얼리버드 티켓 등록하기",
            "_goldbenefits_2": "특별한 페스티벌 입장 게이트 이용하기",
            "_goldbenefits_3": "Ultra Passport라운지로 접속하기",
            "_goldbenefits_4": "우선 순위 고객 서비스",
            "_platinumbenefits_1": "골드&실버 레벨 패스포트 소유자와 일반인 보다 먼저 얼리버드 티켓 구매하기",
            "_platinumbenefits_2": "아티스트 공연을 특별한 장소에서 관람할 수 있는 권한 제공",
            "_platinumbenefits_3": "각 페스티벌의 특별한 혜택"
        },
        "_qualify": {
            "_qualify_1": "Ultra Passport 등록이 성공적으로 완료되었습니다.",
            "_qualify_2": "전체 Ultra Festival 참가하기",
            "_qualify_3": "Road To Ultra 이벤트 참가하기",
            "_qualify_4": "보너스. 해외 울트라 페스티벌 방문",
            "_qualify_5": "보너스 · 홈 이벤트 방문",
            "_qualify_6": "보너스. 홈 이벤트 2회 연속 방문",
            "_qualify_7": "보너스. 홈 이벤트 3회 연속 방문"
        },
        /*"Footer": {
            "email_footer_1": "이 이메일은 ULTRA PASSPORT로부터 발송되었습니다.",
            "email_footer_2": "이 문제에 오류가 있으면, 저희에게 알려주세요.",
            "email_footer_3": "Ultra Passport 주관"
        },
        "Account Confirmation": {
            "email_account_confirmation_subject": "Ultra Passport계정 확인",
            "email_account_confirmation_message": "Ultra Passport계정의 메일 주소를 확인하세요.",
            "email_account_confirmation_button": "계정 활성화"
        },
        "Account Verified": {
            "email_account_verified_subject": "계정이 승인되었습니다.",
            "email_account_verified_message": "Ultra Passport계정의 메일 주소를 확인했습니다. 이제 이벤트에 등록하고 포인트를 획득하여 Ultra Passport 레벨을 올려보세요.",
            "email_account_verified_button": "이벤트 보기"
        },
        "New Email Verification": {
            "email_new_email_verification_subject": "새로운 메일 주소를 확인하세요.",
            "email_new_email_verification_message": "새로운 메일을 확인하려면 아래 버튼을 클릭하세요:",
            "email_new_email_verification_button": "메일 주소를 인증하세요."
        },
        "New Email Verified": {
            "email_new_email_verified_subject": "새로운 메일 주소가 인증되었습니다.",
            "email_new_email_verified_message": "Ultra Passport계정의 새로운 메일 주소가 확인되었습니다.",
            "email_new_email_verified_button": "이벤트 보기"
        },
        "Forgot Password": {
            "email_forgot_password_subject": "Ultra Passport 비밀번호를 재설정해주세요.",
            "email_forgot_password_message": "아래 버튼을 클릭해 비밀번호를 재설정해주세요.",
            "email_forgot_password_button": "비밀번호 재설정"
        },
        "Password Reset": {
            "email_password_reset_subject": "비밀번호가 재설정 되었습니다.",
            "email_password_reset_message": "비밀번호가 재설정되었음을 알려드립니다.",
            "email_password_reset_button": "나의 계정"
        },
        "No Account": {
            "email_no_account_subject": "이 계정은 존재하지 않습니다.",
            "email_no_account_message": "%email%과 관련된 계정을 찾을 수 없습니다. 아래에서 등록하여 계정을 만드세요.",
            "email_no_account_button": "지금 등록"
        },
        "EMAIL LABELS": {
            "email_label_intro": "(성함) 님",
            "email_label_intro_guest": "고객님께",
            "email_label_confirm_receipt": "이 메일 통해 다음과 같은 정보가 전달되었음을 확인하였습니다. 응답이 필요한 경우 가능한 한 빨리 연락드리겠습니다.",
            "email_label_sent_from": "보낸 사람",
            "email_label_generated": "이 이메일은 .$website_link. 사이트로부터 발송되었습니다. 만약 잘못 발송되었다면 우리에게 알려주세요.",
            "email_label_contact_request": "연락처 요청",
            "email_label_point_of_contact": "get_bloginfo(name). 의 연락처로 이 이메일을 수신했습니다. 이 이메일을 더 이상 받지 않으려면 알려주세요.",
            "email_label_terms_of_use": "이용 약관",
            "email_label_privacy_policy": "개인 정보 보호 정책"
        },
        "Form Fields": {
            "email_form_success": "성공",
            "email_form_thank_you": "(이름) [sitename]에 문의해 주셔서 감사합니다. <br><br> 가능한 한 빨리 연락드리겠습니다."
        }*/
    };


    var

    // Config = '// Config',
    locale = 'ko',
    helpurl = 'https://ultrapassport.com/help/',
    _lwidth = '3em';


    // Globals = '// Globals',
    _globalnotice    = ko_strings['globals']['_globalnotice'];
    _globalnotice2   = ko_strings['globals']['_globalnotice2'];
    _globalnoticereg = ko_strings['globals']['_globalnoticereg'];
    _maintenance     = ko_strings['globals']['_maintenance'];
    _guestnotice     = ko_strings['globals']['_guestnotice'];

    // Labels = '// Labels',
    _fullname            = ko_strings['form_labels']['_fullname'];
    _firstname           = ko_strings['form_labels']['_firstname'];
    _lastname            = ko_strings['form_labels']['_lastname'];
    _email               = ko_strings['form_labels']['_email'];
    _emailaddy           = ko_strings['form_labels']['_emailaddy'];
    _confirmemailaddy    = ko_strings['form_labels']['_confirmemailaddy'];
    _birthday            = ko_strings['form_labels']['_birthday'];
    _location            = ko_strings['form_labels']['_location'];
    _country             = ko_strings['form_labels']['_country'];
    _homeevent           = ko_strings['form_labels']['_homeevent'];
    _gender              = ko_strings['form_labels']['_gender'];
    _password            = ko_strings['form_labels']['_password'];
    _male                = ko_strings['form_labels']['_male'];
    _female              = ko_strings['form_labels']['_female'];
    _pleaseselect        = ko_strings['form_labels']['_pleaseselect'];
    _signuptitle         = ko_strings['form_labels']['_signuptitle'];
    _enteryouremail      = ko_strings['form_labels']['_enteryouremail'];
    _backtologin         = ko_strings['form_labels']['_backtologin'];
    _requestnewpass      = ko_strings['form_labels']['_requestnewpass'];
    _on                  = ko_strings['form_labels']['_on'];
    _off                 = ko_strings['form_labels']['_off'];
    _enrollmentavailable = ko_strings['labels']['_enrollmentavailable'];
    _goback              = ko_strings['form_labels']['_goback'];


    // Text Labels = '// Text Labels',
    _logintext  = ko_strings['labels']['_logintext'];
    _password   = ko_strings['labels']['_password'];
    _welcome    = ko_strings['labels']['_welcome'];
    _account    = ko_strings['labels']['_account'];
    _myaccount  = ko_strings['labels']['_myaccount'];
    _mypassport = ko_strings['labels']['_mypassport'];
    _events     = ko_strings['labels']['_events'];
    _points     = ko_strings['labels']['_points'];
    _updates    = ko_strings['labels']['_updates'];
    _signout    = ko_strings['labels']['_signout'];
    _signin     = ko_strings['labels']['_signin'];
    _signedin   = ko_strings['labels']['_signedin'];
    _signuptext = ko_strings['labels']['_signuptext'];
    _nextlevel  = ko_strings['labels']['_nextlevel'];
    _forgot     = ko_strings['labels']['_forgot'];
    _subscribed = ko_strings['labels']['_subscribed'];
    _helpcenter = ko_strings['labels']['_helpcenter'];
    _error      = ko_strings['labels']['_error'];
    _silver     = ko_strings['labels']['_silver'];
    _gold       = ko_strings['labels']['_gold'];
    _platinum   = ko_strings['labels']['_platinum'];

    // Validation Messages = '// Validation Messages',
    _gendertext = ko_strings['validation_messages']['_gendertext'];
    _accepttext = ko_strings['validation_messages']['_accepttext'];


    // Email Verifications = '// Email Verifications',
    _resendverify         = ko_strings['_email_verifications']['_resendverify'];
    _revalidate           = ko_strings['_email_verifications']['_revalidate'];
    _sendingverification  = ko_strings['_email_verifications']['_sendingverification'];
    _verifysent           = ko_strings['_email_verifications']['_verifysent'];
    _emailverifydashboard = ko_strings['_email_verifications']['_emailverifydashboard'];
    _emailverifyupdates   = ko_strings['_email_verifications']['_emailverifyupdates'];


    // Edit Page = '// Edit Page',
    _editaccount          = ko_strings['_edit_page']['_editaccount'];
    _nochanges            = ko_strings['_edit_page']['_nochanges'];
    _accountupdated       = ko_strings['_edit_page']['_accountupdated'];
    _emailupdatedstarted  = ko_strings['_edit_page']['_emailupdatedstarted'];
    _emailupdatedverified = ko_strings['_edit_page']['_emailupdatedverified'];
    _passwordresetsent    = ko_strings['_edit_page']['_passwordresetsent'];


    // Footer Signup = '// Footer Signup',
    _startinput = ko_strings['_footer_signup']['_startinput'];
    _starttext  = ko_strings['_footer_signup']['_starttext'];
    _getstarted = ko_strings['_footer_signup']['_getstarted'];


    // Signup Page = '// Signup Page',
    _createaccount        = ko_strings['_signup_page']['_createaccount'];
    _almost               = ko_strings['_signup_page']['_almost'];
    _almost2              = ko_strings['_signup_page']['_almost2'];
    _almost3              = ko_strings['_signup_page']['_almost3'];
    _almost4              = ko_strings['_signup_page']['_almost4'];
    _almost5              = ko_strings['_signup_page']['_almost5'];
    _createdsuccess       = ko_strings['_signup_page']['_createdsuccess'];
    _createdinfo          = ko_strings['_signup_page']['_createdinfo'];
    _accountactivated     = ko_strings['_signup_page']['_accountactivated'];
    _accountverified      = ko_strings['_signup_page']['_accountverified'];
    _passwordresetsuccess = ko_strings['_signup_page']['_passwordresetsuccess'];


    // Updates = '// Updates',
    _updatestext1       = ko_strings['_updates']['_updatestext1'];
    _updatestextPending = ko_strings['_updates']['_updatestextPending'];
    _updatessubsrcibe   = ko_strings['_updates']['_updatessubsrcibe'];
    _updatesunsubsrcibe = ko_strings['_updates']['_updatesunsubsrcibe'];


    // Registration = '// Registration',
    _rbtnbuy             = ko_strings['_registration']['_rbtnbuy'];
    _regbuy              = ko_strings['_registration']['_regbuy'];
    _rbtnregister        = ko_strings['_registration']['_rbtnregister'];
    _rbtnclosed          = ko_strings['_registration']['_rbtnclosed'];
    _rbtnsoon            = ko_strings['_registration']['_rbtnsoon'];
    _rbtnupdates         = ko_strings['_registration']['_rbtnupdates'];
    _verifyemailregister = ko_strings['_registration']['_verifyemailregister'];
    _regbtnhtml          = ko_strings['_registration']['_regbtnhtml'];
    _regerror            = ko_strings['_registration']['_regerror'];
    _regerror2           = ko_strings['_registration']['_regerror2'];
    _regprocessing       = ko_strings['_registration']['_regprocessing'];
    _registersuccess     = ko_strings['_registration']['_registersuccess'];
    _regaccepted         = ko_strings['_registration']['_regaccepted'];
    _regaccepted2        = ko_strings['_registration']['_regaccepted2'];
    _regaccepted2_2      = ko_strings['_registration']['_regaccepted2_2'];
    _regaccepted2_3      = ko_strings['_registration']['_regaccepted2_3'];
    _regaccepted3        = ko_strings['_registration']['_regaccepted3'];
    _regdone1            = ko_strings['_registration']['_regdone1'];
    _regdone2            = ko_strings['_registration']['_regdone2'];
    _regdone3            = ko_strings['_registration']['_regdone3'];
    _selectregtype       = ko_strings['_registration']['_selectregtype'];
    _regtype             = ko_strings['_registration']['_regtype'];


    // Registrations Confirm = '// Registrations Confirm',
    _regtext1      = ko_strings['_registration_confirm']['_regtext1'];
    _regtext2      = ko_strings['_registration_confirm']['_regtext2'];
    _regguest1     = ko_strings['_registration_confirm']['_regguest1'];
    _regpending1   = ko_strings['_registration_confirm']['_regpending1'];
    _regpending2   = ko_strings['_registration_confirm']['_regpending2'];
    _updateinfobtn = ko_strings['_registration_confirm']['_updateinfobtn'];
    _confirmreg    = ko_strings['_registration_confirm']['_confirmreg'];


    // Privacy / Terms Notice = '// Privacy / Terms Notice',
    privacytext = ko_strings['privacytext'];
    termsofuse  = ko_strings['termsofuse'];

    // Copyright == '// Copyright ',
    upptextlogo    = 'Ultra Passport<span class="tm">&trade;</span>';
    privacylink    = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${ko_strings['_registration_confirm']['privacytext']}</a>`;
    termslink      = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${ko_strings['_registration_confirm']['termsofuse']}</a>`;
    _agreesignup   = ko_strings['_registration_confirm']['_agreesignup'];
    _agreesignup2  = ko_strings['_registration_confirm']['_agreesignup2'];
    _agreeregister = ko_strings['_registration_confirm']['_agreeregister'];


    // Passport Dashboard = '// Passport Dashboard',
    _action            = ko_strings['_passport_labels']['_action'];
    _awarded           = ko_strings['_passport_labels']['_awarded'];
    _award             = ko_strings['_passport_labels']['_award'];
    _benefit           = ko_strings['_passport_labels']['_benefit'];
    _howtoqualify      = ko_strings['_passport_labels']['_howtoqualify'];
    _pointsexpire      = ko_strings['_passport_labels']['_pointsexpire'];
    _qualifydisclaimer = ko_strings['_passport_labels']['_qualifydisclaimer'];
    _active            = ko_strings['_passport_labels']['_active'];
    _deleted           = ko_strings['_passport_labels']['_deleted'];
    _btn_dashboard     = ko_strings['_passport_labels']['_btn_dashboard'];
    _btn_benefits      = ko_strings['_passport_labels']['_btn_benefits'];
    _btn_qualify       = ko_strings['_passport_labels']['_btn_qualify'];
    _btn_points        = ko_strings['_passport_labels']['_btn_points'];

    leveltext = _silver;
    nextlevel = _gold;

    var _birthdayselect = '<div class="datefield"><span class="subfield monthfield"><select class="required" id="birthmonth" name="birthmonth" style="width:80px;display:inline-block"><option value="" disabled selected>MM</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option></select></span><span class="spacer">/</span> <span class="subfield dayfield"><select class="required" id="birthday" name="birthday" style="width:80px;display:inline-block" data-field="birthday"><option value="" disabled selected>DD</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option></select></span><span class="spacer">/</span> <span class="subfield yearfield"><select class="required" id="birthyear" name="birthyear" style="width:100px;display:inline-block"><option disabled selected>YYYY</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option><option value="1920">1920</option><option value="1919">1919</option><option value="1918">1918</option><option value="1917">1917</option><option value="1916">1916</option><option value="1915">1915</option><option value="1914">1914</option><option value="1913">1913</option><option value="1912">1912</option><option value="1911">1911</option><option value="1910">1910</option><option value="1909">1909</option><option value="1908">1908</option><option value="1907">1907</option><option value="1906">1906</option><option value="1905">1905</option><option value="1904">1904</option><option value="1903">1903</option><option value="1902">1902</option><option value="1901">1901</option><option value="1900">1900</option></select></span></div>';

    // Errors : '// Errors',
    var errors = ko_strings['_errors'];

    // Point Labels : '// Point Labels'
    var pointcodes = {
        manual : ko_strings['_point_labels']['_points_manual'],
        verify : ko_strings['_point_labels']['_points_verify'],
        unknown : ko_strings['_point_labels']['_points_unknown'],
        attend_festival : ko_strings['_point_labels']['_points_attend_festival'],
        attend_rtu : ko_strings['_point_labels']['_points_attend_rtu'],
        attend_resistance : ko_strings['_point_labels']['_points_attend_resistance'],
        away_bonus : ko_strings['_point_labels']['_points_away_bonus'],
        home_bonus_1 : ko_strings['_point_labels']['_points_home_bonus_1'],
        home_bonus_2 : ko_strings['_point_labels']['_points_home_bonus_2'],
        home_bonus_3 : ko_strings['_point_labels']['_points_home_bonus_3'],
    };
}
